import {Flex, Input, Select} from 'antd'
import {useEffect, useState} from "react";

interface SizeInfo {
    width: number,
    height: number,
    name?: string
}

export enum SizeFormatType {
    BANNER = 'BANNER', VIDEO = 'VIDEO'
}

export const BANNER_SIZES = Array<SizeInfo>(
    {width: 300, height: 250, name: 'Medium Rectangle'},
    {width: 336, height: 280, name: '336x280 – Large Rectangle'},
    {width: 728, height: 90, name: 'Leaderboard'},
    {width: 320, height: 100, name: 'Large Mobile Banner'},
    {width: 320, height: 50, name: 'Mobile Leaderboard'},
    {width: 300, height: 50, name: 'Small Mobile Banner'},
    {width: 160, height: 600, name: 'Wide Skyscraper'},
    {width: 120, height: 600, name: 'Skyscraper'},
    {width: 300, height: 600, name: 'Half Page Ad'},
    {width: 970, height: 250, name: 'Billboard'},
    {width: 970, height: 90, name: 'Large Leaderboard'}
)

export const VIDEO_SIZES = Array<SizeInfo>(
    {width: 1024, height: 728, name: 'Standard 2:3'}
)

type SizeSelectorProps = {
    format: SizeFormatType,
    width?: number,
    height?: number,
    onChange: (width?: number, height?: number) => void,
    disabled?: boolean
}

export default function SizeSelector({format, width, height, onChange, disabled}: SizeSelectorProps) {

    const [sizesOptions, setSizesOptions] = useState<Array<any>>([])

    useEffect(() => {
        const newSizesOptions = (format == SizeFormatType.BANNER ? BANNER_SIZES : VIDEO_SIZES).map(item =>({
            label: `${item.width}x${item.height}${item.name ? ' - ' : ''}${item.name || ''}`,
            value: `${item.width}x${item.height}`
        })).sort((opt1, opt2) => opt1.label.localeCompare(opt2.label))
        setSizesOptions(newSizesOptions)
    }, [format]);

    return (
        <Flex gap={8}>
            <Select
                options={sizesOptions}
                value={sizesOptions.find(opt => opt.value === `${width}x${height}`)?.value || undefined}
                placeholder={width == undefined && height == undefined ? 'Select Predefined Size' : 'Custom Size'}
                disabled={disabled}
                onChange={(key) => {
                    const parts = key.split('x')
                    onChange(parseInt(parts[0]), parseInt(parts[1]))
                }}
            >
            </Select>
            <Input
                style={{ width: '100' }}
                type="number"
                min={0}
                placeholder="Width"
                value={width || ''}
                onChange={(value) => onChange(parseInt(value.target.value), height)}
                disabled={disabled}
                allowClear
            />
            x
            <Input
                style={{ width: '100' }}
                type="number"
                min={0}
                placeholder="Height"
                value={height || ''}
                onChange={(value) =>  onChange(width, parseInt(value.target.value))}
                disabled={disabled}
                allowClear
            />
        </Flex>
    )
}